export const BRAND = {
  name: "EquipmentHub India",
  tagline: "India's Heavy Equipment Marketplace",
  footerText: "Connecting Equipment & Projects Across India.",
  contactEmail: "info@equipmenthubindia.com",
  whatsappNumber: "918602334144",
  whatsappDisplay: "+91 86023 34144",
  logoUrl:
    "https://customer-assets-jt897jd0.emergentagent.net/job_supplier-connect-113/artifacts/5zzh43aj_Gemini_Generated_Image_dnmr9adnmr9adnmr.webp",
  primary: "#0A3D7A",
  primaryHover: "#082C57",
  accent: "#F57C00",
  accentHover: "#D96A00",
};

import { ALL_SUBCATEGORIES, TAXONOMY } from "@/lib/taxonomy";

// Flat list of every leaf category (for select dropdowns & filters).
// Some subcategory IDs (e.g. "tower-crane", "truck-mounted-crane") appear in multiple
// groups intentionally — but for flat select lists we dedupe by id to keep React keys unique.
const _seenIds = new Set();
export const CATEGORIES = ALL_SUBCATEGORIES.filter((s) => {
  if (_seenIds.has(s.id)) return false;
  _seenIds.add(s.id);
  return true;
}).map((s) => ({ id: s.id, name: s.name, group: s.group_name }));

export const CATEGORY_GROUPS = TAXONOMY.map((g) => ({ id: g.id, name: g.name }));

export const DURATION_OPTIONS = [
  "1 day", "1 week", "15 days", "1 month", "3 months", "6 months", "1 year+",
];

export const AVAILABILITY_OPTIONS = [
  { id: "immediate", label: "Available now" },
  { id: "7-days", label: "Within 7 days" },
  { id: "30-days", label: "Within 30 days" },
  { id: "flexible", label: "Flexible" },
];

export const STATES = [
  "Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Delhi","Goa","Gujarat","Haryana","Himachal Pradesh",
  "Jharkhand","Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland","Odisha",
  "Puducherry","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura","Uttar Pradesh","Uttarakhand","West Bengal",
  "Jammu and Kashmir","Ladakh","Andaman and Nicobar","Chandigarh","Dadra and Nagar Haveli","Daman and Diu","Lakshadweep",
];
export const INDIAN_CITIES = [
  "Mumbai", "Pune", "Delhi", "Bengaluru", "Chennai", "Hyderabad",
  "Ahmedabad", "Kolkata", "Surat", "Jaipur", "Lucknow", "Nagpur",
  "Gurgaon", "Noida", "Coimbatore", "Kochi", "Indore", "Bhopal",
];

export const CAPACITY_OPTIONS = [
  "1-5 Ton", "5-20 Ton", "20-50 Ton", "50-100 Ton", "100+ Ton",
  "10-20 Meter", "20-40 Meter", "40+ Meter",
  "50-200 kVA", "200-500 kVA", "500+ kVA",
];

export function formatINR(n) {
  if (n == null || Number.isNaN(Number(n))) return "—";
  const num = Number(n);
  if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `₹${(num / 100000).toFixed(2)} L`;
  return `₹${num.toLocaleString("en-IN")}`;
}

/**
 * Normalise any rental price → monthly display for consistency.
 * Assumes 30 days per month (calendar) — industry convention for Indian equipment rental.
 * For non-rental listings (sale/total price), returns null so caller can render "Sale price".
 */
export function monthlyRentalPrice(item) {
  if (!item || item.price == null) return null;
  if (item.listing_type && item.listing_type !== "rental" && item.listing_type !== "rent") return null;
  const price = Number(item.price);
  if (!price) return null;
  const unit = item.price_unit || "per_day";
  if (unit === "per_month") return price;
  if (unit === "per_day") return price * 30;
  if (unit === "per_week") return price * 4;
  return null; // "total" or unknown → don't fake a monthly figure
}

export function formatMonthlyRent(item) {
  const m = monthlyRentalPrice(item);
  if (m != null) return `${formatINR(m)} / month`;
  // Fallbacks
  if (item?.price == null) return "—";
  return formatINR(item.price);
}
